import { mapState } from 'vuex'

export default {
  props: {
    clientApiId: String
  },
  data () {
    return {
      editEl: null,
      loading: false,
      updating: false,
      minperiod: null,
      cancelClientRates: false
    }
  },
  computed: {
    ...mapState(['config']),
    getTitle () {
      return this.$t('menu.material.multi-edit');
    },
    datePeriodOptions () {
      const options = [];
      if (this.config);
      const perConfig = (this.config ? this.config.datePeriodConfig : null);
      const minPerConf = this.BasicHelper.datePeriodCodeToData(this.minperiod);
      if (perConfig && minPerConf) {
        let year = perConfig.endYear;
        while (year >= minPerConf.year) {
          for (let i = perConfig.periodCount; i > 0; i--) {
            if ((year === minPerConf.year) && i < (minPerConf.period)) {
              i = 0;
            } else {
              options.push({ value: year + '0' + i + '0', label: this.$tc('general.datePeriod.short', i, { year: year, period: i }) });
            }
          }
          year -= 1;
        }
        if (!this.editEl.from_date_period_id && options.length > 0) {
          this.editEl.from_date_period_id = options[options.length - 1].value;
        }
      }
      return options;
    },
    materialGroupOptions () {
      return this.$store.getters.getConfigOptions('material_groups', this.$i18n.locale);
    },
    yesNoOptions () {
      return this.BasicHelper.yesNoOptions();
    },
    requestPath () {
      let path = 'material/material/active-rates/' + this.editEl.material_group;
      if (this.clientApiId) {
        path += '/' + this.clientApiId;
      }
      return path;
    }
  },
  methods: {
    getMaterialRateConfig () {
      this.loading = true;
      const self = this;
      this.ApiRequest.request(this.requestPath, this.ApiRequest.REQUEST_GET, {}, function (response) {
        if (response.data) {
          self.minperiod = response.data.minperiod;
          self.editEl.materials = response.data.rates;
        } else {
          self.editEl.materials = null;
        }
        self.loading = false;
      });
    },
    save (approved = false) {
      if (!approved && this.cancelClientRates) {
        const periodStr = this.$tc('general.datePeriod.short',
          this.BasicHelper.datePeriodCodeToData(this.editEl.from_date_period_id).period, this.BasicHelper.datePeriodCodeToData(this.editEl.from_date_period_id)
        )
        this.$refs.approveSaveMsgBox.show(
          '',
          this.$t('menu.material.multi-edit-global.cancelClientRatesTitle'),
          this.$t('menu.material.multi-edit-global.cancelClientRatesMessage', { period: periodStr })
        )
      } else {
        const self = this;
        self.updating = true;
        const reqData = {};
        reqData.from_date_period_id = this.editEl.from_date_period_id;
        if (this.clientApiId) {
          reqData.clientApiId = this.clientApiId;
        } else {
          reqData.cancelClientRates = this.cancelClientRates;
          reqData.material_group = this.editEl.material_group;
        }
        reqData.materials = {};
        this.editEl.materials.forEach(mat => {
          reqData.materials[mat.code] = {
            rate: (mat.isAllowed ? mat.rate : null),
            isAllowed: mat.isAllowed
          }
          if (self.clientApiId) {
            reqData.materials[mat.code].useDefaultRate = mat.useDefaultRate;
          }
        });
        this.ApiRequest.request('material/material/rates-edit', this.ApiRequest.REQUEST_POST, reqData, function (response) {
          if (response.error) {
            self.ApiRequest.displayErrorDialog(response, self);
            self.updating = false;
          } else {
            self.$emit('saved');
            self.close();
            self.updating = false;
          }
        });
      }
    },
    show () {
      this.editEl = { material_group: this.materialGroupOptions[0].code, from_date_period_id: null, materials: null };
      this.cancelClientRates = false;
      this.getMaterialRateConfig();
      this.$refs['modal-window'].show();
    },
    close () {
      this.editEl = null;
      this.$refs['modal-window'].hide();
    },
    rateCanBeModified (material) {
      return (material.isAllowed == 1 && !(this.clientApiId && material.useDefaultRate == 1))
    },
    rateIsModified (material) {
      return material.rate && this.rateCanBeModified(material)
    },
    getDiscountedRate (rate, discount) {
      if (rate && discount) {
        return this.$options.filters.formatDecimal(parseFloat(rate) * (1 - discount), 4, this.$i18n.locale);
      }
      return '';
    }
  }
}
